import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AC_ACTIVITY_LOG_LIST_PARAMS,
  ACTIVITY_LOGS_RESULT,
} from 'models/activity-logs';

export interface ActivityLogType {
  activityLogs: {
    list: ACTIVITY_LOGS_RESULT;
  };
}

const initialState: ActivityLogType = {
  activityLogs: {
    list: {
      records: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      params: {
        sort: 'createdAt-desc',
        page: 1,
        limit: 50,
      },
    },
  },
};

const activityLogSlice = createSlice({
  name: 'activity-logs',
  initialState,
  reducers: {
    setActivityLogListSuccess(
      state: ActivityLogType,
      action: PayloadAction<ACTIVITY_LOGS_RESULT>
    ) {
      state.activityLogs.list = {
        ...state.activityLogs.list,
        ...action.payload,
      };
    },
    setActivityLogListParams(
      state: ActivityLogType,
      action: PayloadAction<AC_ACTIVITY_LOG_LIST_PARAMS>
    ) {
      state.activityLogs.list.params = action.payload;
    },
  },
});

// Actions
export const { setActivityLogListSuccess, setActivityLogListParams } =
  activityLogSlice.actions;

export default activityLogSlice.reducer;
